var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _MatchComponents = require("./MatchComponents");

var _Logos = require("../Basic/Logos");

var _Basic = require("../../../elements/Basic");

var _i18n = _interopRequireDefault(require("../../../i18n"));

var _HeaderComponents = require("../Liveticker/Header/Components/HeaderComponents");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Match/TeamMatch.js";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var TeamMatch = function (_React$Component) {
  (0, _inherits2.default)(TeamMatch, _React$Component);

  var _super = _createSuper(TeamMatch);

  function TeamMatch() {
    (0, _classCallCheck2.default)(this, TeamMatch);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(TeamMatch, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          homeTeam = _this$props.homeTeam,
          awayTeam = _this$props.awayTeam,
          homeScore = _this$props.homeScore,
          awayScore = _this$props.awayScore,
          homePenaltyScore = _this$props.homePenaltyScore,
          awayPenaltyScore = _this$props.awayPenaltyScore,
          period = _this$props.period,
          isLive = _this$props.isLive,
          scheduledStartTime = _this$props.scheduledStartTime,
          matchInfo = _this$props.matchInfo,
          containerStyles = _this$props.containerStyles,
          invertTeamAlignment = _this$props.invertTeamAlignment,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["homeTeam", "awayTeam", "homeScore", "awayScore", "homePenaltyScore", "awayPenaltyScore", "period", "isLive", "scheduledStartTime", "matchInfo", "containerStyles", "invertTeamAlignment"]);
      var resultType = period !== 'PRE_MATCH' && matchInfo ? matchInfo.resultType : '';
      var showBottomSpace = resultType !== 'AFTER_EXTRA_TIME' && resultType !== 'PENALTY_SHOOTOUT' && !isLive;
      return _react.default.createElement(_Basic.View, (0, _extends2.default)({}, containerStyles, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 47,
          columnNumber: 13
        }
      }), _react.default.createElement(_Basic.Row, {
        center: true,
        mt: 2,
        mb: showBottomSpace ? 2 : 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 48,
          columnNumber: 17
        }
      }, _react.default.createElement(_MatchComponents.TeamName, (0, _extends2.default)({
        textAlign: invertTeamAlignment ? 'right' : 'left',
        py: 0
      }, _objectSpread({
        homeTeam: homeTeam
      }, rest), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 49,
          columnNumber: 21
        }
      }), homeTeam && (homeTeam.shortName || homeTeam.name)), _react.default.createElement(_Logos.TeamLogo, {
        size: 20,
        mx: 2,
        my: 0,
        src: (0, _get.default)(homeTeam, 'imageUrl'),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 56,
          columnNumber: 21
        }
      }), _react.default.createElement(_Basic.Row, {
        center: true,
        width: 60,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 57,
          columnNumber: 21
        }
      }, function () {
        switch (resultType) {
          case 'POSTPONED':
            return _react.default.createElement(_Basic.Text, {
              size: "small",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 61,
                columnNumber: 44
              }
            }, (0, _i18n.default)('match_postponed'));

          case 'ABANDONED':
            return _react.default.createElement(_Basic.Text, {
              size: "small",
              __source: {
                fileName: _jsxFileName,
                lineNumber: 63,
                columnNumber: 44
              }
            }, (0, _i18n.default)('match_abandoned'));

          default:
            return _react.default.createElement(_MatchComponents.MatchScore, (0, _extends2.default)({
              size: "large"
            }, _objectSpread({
              homeScore: homeScore,
              awayScore: awayScore,
              homePenaltyScore: homePenaltyScore,
              awayPenaltyScore: awayPenaltyScore,
              period: period,
              scheduledStartTime: scheduledStartTime
            }, rest), {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 66,
                columnNumber: 41
              }
            }));
        }
      }()), _react.default.createElement(_Logos.TeamLogo, {
        size: 20,
        mx: 2,
        my: 0,
        src: (0, _get.default)(awayTeam, 'imageUrl'),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 82,
          columnNumber: 21
        }
      }), _react.default.createElement(_MatchComponents.TeamName, (0, _extends2.default)({
        textAlign: invertTeamAlignment ? 'left' : 'right',
        py: 0
      }, _objectSpread({
        awayTeam: awayTeam
      }, rest), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 83,
          columnNumber: 21
        }
      }), awayTeam && (awayTeam.shortName || awayTeam.name))), _react.default.createElement(_Basic.Row, {
        center: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 91,
          columnNumber: 17
        }
      }, isLive ? _react.default.createElement(_MatchComponents.LiveMinute, {
        mt: 1,
        minute: (0, _get.default)(matchInfo, 'matchMinute'),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 93,
          columnNumber: 25
        }
      }) : _react.default.createElement(_react.default.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 95,
          columnNumber: 25
        }
      }, {
        AFTER_EXTRA_TIME: _react.default.createElement(_HeaderComponents.Info, {
          my: 0,
          size: "small",
          __source: {
            fileName: _jsxFileName,
            lineNumber: 99,
            columnNumber: 41
          }
        }, (0, _i18n.default)('result.after_extra_time')),
        PENALTY_SHOOTOUT: _react.default.createElement(_HeaderComponents.Info, {
          my: 0,
          size: "small",
          __source: {
            fileName: _jsxFileName,
            lineNumber: 104,
            columnNumber: 41
          }
        }, (0, _i18n.default)('result.penalty_shootout'))
      }[resultType])));
    }
  }]);
  return TeamMatch;
}(_react.default.Component);

TeamMatch.propTypes = {
  homeTeam: _propTypes.default.object.isRequired,
  awayTeam: _propTypes.default.object.isRequired,
  homeScore: _propTypes.default.number.isRequired,
  awayScore: _propTypes.default.number.isRequired,
  homePenaltyScore: _propTypes.default.number,
  awayPenaltyScore: _propTypes.default.number,
  period: _propTypes.default.string,
  matchInfo: _propTypes.default.object,
  containerStyles: _propTypes.default.object,
  invertTeamAlignment: _propTypes.default.bool
};
var _default = TeamMatch;
exports.default = _default;